export default __webpack_public_path__ + "static/media/Bluehouse.87f0f71e.svg";